import React from 'react';
import { Loader2 } from 'lucide-react';
import './SaveButton.css';
import { useScreenAccess } from './PermissionsContext';

// The Save-side counterpart to CancelButton — same reasoning: one place for
// color/hover/disabled behavior instead of every form re-declaring its own
// (previously via page-scoped CSS keyed off `button[type="submit"]`, which
// is exactly what let 26 forms' Save/Cancel buttons drift into slightly
// different colors/padding/radius from each other and from this component).
// `loading` drives the disabled state, a spinner and the "Saving..."
// label (Spinner While an API Call Runs, ui-architecture.md);
// `disabled` still applies on top of it for extra conditions. Not shown on
// a screen the staff member can only read (issue #252).
function SaveButton({ onClick, loading, disabled, type = 'submit', style, children, ...rest }) {
  const { canCreate, canUpdate } = useScreenAccess();
  if (!canCreate && !canUpdate) return null;
  return (
    <button
      type={type}
      className="save-button"
      onClick={onClick}
      disabled={loading || disabled}
      style={style}
      {...rest}
    >
      {loading && <Loader2 size={13} className="save-button-spinner" aria-hidden="true" />}
      {children || (loading ? 'Saving...' : 'Save')}
    </button>
  );
}

export default SaveButton;
